import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';

import { MainPage } from '../main/main';

import { AlertProvider } from '../../providers/alert/alert';
import { MediaProvider } from '../../providers/media/media';
import { DateTimeProvider } from '../../providers/datetime/datetime';
import { QuizzServerProvider } from '../../providers/quizz-server/quizz-server';
import { ProofServerProvider } from '../../providers/proof-server/proof-server';

import { MediaItem } from '../../models/mediaitem';

/**
 * Generated class for the QuizzQuestionSelfieOnAppPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-question-selfie-on-app',
  templateUrl: 'quizz-question-selfie-on-app.html',
})
export class QuizzQuestionSelfieOnAppPage {

  selfieColor: string = 'danger';

  quizzId: number = null;
  questionId: number = null;

  constructor(
    private navCtrl: NavController,
    private alert: AlertProvider,
    private mediaProvider: MediaProvider,
    private dateTimeProvider: DateTimeProvider,
    private quizzServerProvider: QuizzServerProvider,
    private proofServerProvider: ProofServerProvider,
  ) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad QuizzQuestionSelfieOnAppPage');
    this.quizzId = this.quizzServerProvider.getQuizzId();
    this.questionId = this.quizzServerProvider.getQuestionId();
  }

  doContinue() {
    if (this.selfieColor !== 'danger') {
      this.navCtrl.setRoot(MainPage);
      this.navCtrl.popToRoot({
        animation: 'ios-transition'
      }, () => {
        // Do nothing.
      });
    } else {
      this.alert.doAlert('Existem informações a serem fornecidas.');
    }
  }

  takeSelfie() {
    if (this.selfieColor === 'danger') {
      const that = this;

      this.mediaProvider.takeSelfie(true).then((selfie) => {
        that.selfieColor = (selfie !== null) ? 'primary' : 'danger';

        // console.log('takeSelfie');
        // console.log(selfie);
        // console.log('selfieColor: ' + that.selfieColor);

        let item = new MediaItem();
        item.id = that.dateTimeProvider.getISOString();
        item.base64 = true;
        item.kind = 'QT';
        item.questionId = that.questionId;
        item.contentOrPath = selfie;
        item.captured = item.id;
        // console.log(item);

        that.proofServerProvider.setMedias([item]);
        //that.proofServerProvider.sendMediaItem(that.quizzId);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-question-selfie-on-app/quizz-question-selfie-on-app.ts